"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = void 0;
class Subscription {
}
exports.Subscription = Subscription;
//# sourceMappingURL=Subscription.js.map